import { Core } from "@faire/slate/foundation/color";
import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { EmbeddedLink } from "@faire/web/ui/EmbeddedLink";
import styled from "styled-components";

const PILL_BORDER_RADIUS = 100;

const StyledPill = styled(EmbeddedLink)`
  display: flex;
  align-items: center;
  padding: ${getSpacing("1x", "3x", "1x", "2x")};
  border-radius: ${getSpacing(PILL_BORDER_RADIUS)};
  background-color: ${Core.surface.tertiary};
  white-space: nowrap;
  margin-right: ${getSpacing("2x")};

  &,
  &:hover,
  &:focus,
  &:focus-within {
    text-decoration: none;
  }

  ${responsiveMediaQueries.tabletAndAbove} {
    &:hover {
      background-color: ${Core.surface.tertiary};
    }
  }
`;

const StyledTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export namespace SearchIconPillStyles {
  export const Pill = StyledPill;
  export const TextWrapper = StyledTextWrapper;
}
